import { Payments } from 'src/components/payment/Payments'

export const PaymentsPage = () => {
  return <Payments />
}
